var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module cercaliagl/view/VTraffic
 */
import $ from 'jquery';
import { MDCSlider } from '@material/slider';
import BaseView from './BaseView.js';
import { i18n } from '../dictionary.js';
import { createSlider } from './VUtils.js';
/**
 * @typedef {Object} ForecastOptions
 * @property {number} departuredayofweek Day of week
 * @property {number} departurefrommidnight Second of day. 0 to 86400
 */
/**
 * @enum {string}
 */
export var EventType = {
    CHANGE_MODE: 'change_mode',
    ENABLE_BUTTON: 'enable_button',
    DISABLE_BUTTON: 'disable_button',
    FORECAST_CHANGE: 'forecast_change',
};
/**
 * @enum {string}
 */
export var View = {
    LIVE: 'live',
    FORECAST: 'forecast',
};
/**
 * @enum {string}
 */
export var Buttons = {
    CAMERAS: 'cameras',
    MILESTONE: 'milestone',
    ROADWORKS: 'roadworks',
};
/**
 * @param {number} dow Day of week
 * @return {string} Day
 */
function getStringDay(dow) {
    if (dow === 1) {
        return i18n('sunday');
    }
    if (dow === 2) {
        return i18n('monday');
    }
    if (dow === 3) {
        return i18n('tuesday');
    }
    if (dow === 4) {
        return i18n('wednesday');
    }
    if (dow === 5) {
        return i18n('thursday');
    }
    if (dow === 6) {
        return i18n('friday');
    }
    if (dow === 7) {
        return i18n('saturday');
    }
    return null;
}
/**
 * @private
 * @param {number} minutes Minutes
 * @return {string} hh:mm format
 */
function minutesToHHMM(minutes) {
    var h = Math.floor(minutes / 60);
    var m = minutes % 60;
    return "".concat(h < 10 ? "0".concat(h) : h, ":").concat(m < 10 ? "0".concat(m) : m);
}
/**
 * @param {ForecastOptions} forecastOptions Forecast option
 * @return {string} Day and time. For example: Monday - 08:00
 */
function getDayTime(forecastOptions) {
    var strDay = getStringDay(forecastOptions.departuredayofweek);
    var dayTime = "".concat(strDay, " ").concat(minutesToHHMM(forecastOptions.departurefrommidnight / 60));
    return dayTime;
}
/**
 * @classdesc
 */
var VTraffic = /** @class */ (function (_super) {
    __extends(VTraffic, _super);
    /**
     * @constructor
     */
    function VTraffic() {
        var _this = this;
        var date = new Date();
        var currentMinutesStep = Math.floor(((60 * date.getHours()) + 60) / 5);
        var jqElement = $("\n      <div class=\"v-traffic mdc-elevation--z4\">\n        <div class=\"switcher\">\n          <span class=\"modeSelected selected\">".concat(i18n('liveTraffic'), "</span>\n          <ul class=\"select view mdc-elevation--z4\">\n            <li data-view=\"").concat(View.LIVE, "\">").concat(i18n('liveTraffic'), "</li>\n            <li data-view=\"").concat(View.FORECAST, "\">").concat(i18n('forecastTraffic'), "</li>\n          </ul>\n        </div>\n        <div class=\"legend\">\n          <span>Slow</span>\n          <div class=\"bars\">\n            <span class=\"red\"></span>\n            <span class=\"orange\"></span>\n            <span class=\"yellow\"></span>\n            <span class=\"green\"></span>\n          </div>\n          <span>Fast</span>\n        </div>\n        <div class=\"live\">\n          <div class=\"buttons\">\n            <span data-name=\"").concat(Buttons.CAMERAS, "\" class=\"btn icon-cameras\"></span>\n            <span data-name=\"").concat(Buttons.MILESTONE, "\" class=\"btn icon-milestone\"></span>\n            <span data-name=\"").concat(Buttons.ROADWORKS, "\" class=\"btn icon-roadworks\"></span>\n          </div>\n        </div>\n        <div class=\"forecast\">\n          <div class=\"daytimebox\">\n            <div class=\"seldaydiv\">\n              <span class=\"daySelected selected\">").concat(i18n('monday'), " ").concat(minutesToHHMM(currentMinutesStep), "</span>\n              <ul class=\"select day mdc-elevation--z4\">\n                <li data-day=\"monday\" data-dow=\"2\">").concat(i18n('monday'), "</li>\n                <li data-day=\"tuesday\" data-dow=\"3\">").concat(i18n('tuesday'), "</li>\n                <li data-day=\"wednesday\" data-dow=\"4\">").concat(i18n('wednesday'), "</li>\n                <li data-day=\"thursday\" data-dow=\"5\">").concat(i18n('thursday'), "</li>\n                <li data-day=\"friday\" data-dow=\"6\">").concat(i18n('friday'), "</li>\n                <li data-day=\"saturday\" data-dow=\"7\">").concat(i18n('saturday'), "</li>\n                <li data-day=\"sunday\" data-dow=\"1\">").concat(i18n('sunday'), "</li>\n              </ul>\n            </div>\n            <div class=\"seltimediv\">\n              ").concat(createSlider('timeslider', 0, 287, currentMinutesStep, false), "\n            </div>\n          </div>\n          <div>\n            <div class=\"legend\">\n              <div class=\"div-sep\">\n                <div class=\"sep-small\" style=\"left:0%\"></div>\n                <div class=\"sep\" style=\"left:12%\">\n                  <div class=\"lab-hour\">03</div>\n                </div>\n                <div class=\"sep-small\" style=\"left:25%\"></div>\n                <div class=\"sep\" style=\"left:37%\">\n                  <div class=\"lab-hour\">09</div>\n                </div>\n                <div class=\"sep-small\" style=\"left:50%\"></div>\n                <div class=\"sep\" style=\"left:62%\">\n                  <div class=\"lab-hour\">15</div>\n                </div>\n                <div class=\"sep-small\" style=\"left:75%\"></div>\n                <div class=\"sep\" style=\"left:87%\">\n                  <div class=\"lab-hour\">21</div></div>\n                <div class=\"sep-small\" style=\"left:100%\"></div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>"));
        _this = _super.call(this, jqElement) || this;
        /**
         * @private
         * @type {string}
         */
        _this.currentView_ = View.LIVE;
        /**
         * @private
         * @type {ForecastOptions}
         */
        _this.forecastOptions_ = {
            departuredayofweek: date.getDay(),
            departurefrommidnight: currentMinutesStep * 5 * 60, // in seconds (step precision -> 5 minutes)
        };
        _this.initialize_();
        return _this;
    }
    /**
     * @private
     */
    VTraffic.prototype.initialize_ = function () {
        var _this = this;
        // Select view
        if (!this.jqElement_) {
            return;
        }
        var jqModeSelected = this.jqElement_.find('.modeSelected');
        var jqSelectView = this.jqElement_.find('ul.select.view');
        if (!jqModeSelected || !jqSelectView) {
            return;
        }
        jqModeSelected.click(function () { return _this.jqElement_.find('ul.select.view').toggle(); });
        jqSelectView.click(function (e) {
            var mdcTimeSlider;
            var view = e.currentTarget.dataset.view;
            _this.toggleView(view);
            if (view === View.FORECAST) {
                _this.jqElement_.find('.live span.btn').removeClass('active'); // Disable active live buttons (roadworks, milestone, cameras)
                if (!mdcTimeSlider) { // Initialize only first time
                    mdcTimeSlider = new MDCSlider(_this.jqElement_.find('.timeslider').get(0));
                    var sliderTimeoutId_1 = null;
                    mdcTimeSlider.listen('MDCSlider:change', function () {
                        // This event is dispatched twice
                        if (sliderTimeoutId_1) {
                            clearTimeout(sliderTimeoutId_1);
                        }
                        sliderTimeoutId_1 = setTimeout(function () {
                            sliderTimeoutId_1 = null;
                            _this.forecastOptions_.departurefrommidnight = Math.round(mdcTimeSlider.getValue()) * 60 * 5; // To seconds
                            _this.jqElement_.find('.daySelected').text(getDayTime(_this.forecastOptions_));
                            _this.emit(EventType.FORECAST_CHANGE, _this.forecastOptions_);
                        }, 50);
                    });
                    mdcTimeSlider.listen('MDCSlider:input', function () {
                        _this.forecastOptions_.departurefrommidnight = Math.round(mdcTimeSlider.getValue()) * 60 * 5; // To seconds
                        _this.jqElement_.find('.daySelected').text(getDayTime(_this.forecastOptions_));
                    });
                }
            }
            _this.jqElement_.find('ul.select.view').hide();
        });
        // Live buttons
        this.jqElement_.find('.live span.btn').click(function (e) {
            var jqButtonClicked = $(e.currentTarget);
            if (jqButtonClicked.hasClass('active')) {
                jqButtonClicked.removeClass('active');
                _this.emit(EventType.DISABLE_BUTTON, jqButtonClicked.data('name'));
            }
            else {
                jqButtonClicked.addClass('active');
                _this.emit(EventType.ENABLE_BUTTON, jqButtonClicked.data('name'));
            }
        });
        // Forecast -> Select day
        this.jqElement_.find('.daySelected').click(function () { return _this.jqElement_.find('ul.select.day').toggle(); });
        this.jqElement_.find('ul.select.day > li').click(function (e) {
            var dow = e.currentTarget.dataset.dow;
            _this.forecastOptions_.departuredayofweek = parseInt(dow, 10);
            _this.jqElement_.find('ul.select.day').hide();
            _this.jqElement_.find('.daySelected').text(getDayTime(_this.forecastOptions_));
            _this.emit(EventType.FORECAST_CHANGE, _this.forecastOptions_);
        });
    };
    /**
     * Toggle view
     * @param {string} view View
     */
    VTraffic.prototype.toggleView = function (view) {
        var textModeSel;
        if (view === View.LIVE) {
            this.jqElement_.find('.forecast').hide();
            this.jqElement_.find('.live').show();
            textModeSel = i18n('liveTraffic');
        }
        else {
            this.jqElement_.find('.live').hide();
            this.jqElement_.find('.forecast').show();
            textModeSel = i18n('forecastTraffic');
        }
        this.jqElement_.find('.modeSelected').text(textModeSel);
        this.currentView_ = view;
        this.emit(EventType.CHANGE_MODE, view);
    };
    /**
     * @param {string} name Name
     */
    VTraffic.prototype.enableButton = function (name) {
        var btn = this.jqElement_.find(".live span.icon-".concat(name));
        btn.addClass('active');
        this.emit(EventType.ENABLE_BUTTON, btn.data('name'));
    };
    /**
     * @param {string} name Name
     */
    VTraffic.prototype.disableButton = function (name) {
        var btn = this.jqElement_.find(".live span.icon-".concat(name));
        btn.removeClass('active');
        this.emit(EventType.DISABLE_BUTTON, btn.data('name'));
    };
    /**
     * Return current view (mode). Live or Forecast
     * @return {string} View
     */
    VTraffic.prototype.getActiveTraffic = function () {
        return this.currentView_;
    };
    /**
     * @return {ForecastOptions} Forecast options
     */
    VTraffic.prototype.getForecastOptions = function () {
        return this.forecastOptions_;
    };
    return VTraffic;
}(BaseView));
export default VTraffic;
//# sourceMappingURL=VTraffic.js.map